import { Outlet } from "react-router";

export default function Posts() {
  return (
    <div className="prose max-w-screen-lg py-10 lg:prose-xl">
      <Outlet />
    </div>
  );
}
